import React, { useEffect, useMemo, useState } from "react";
import DaterangePicker from "../../common/Daterangepicker";
import Pettcashdetailtab from "../pettycash/Pettcashdetailtab";
import { useSelector } from "react-redux";

const Wheelalignmentdashboard = () => {
  const cities = useSelector((state) => state?.cities?.citiesData);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const [wheelalignmentData, setWheelAlignmentData] = useState([]);
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);
  const [selectionRange, setSelectionRange] = useState({
    startDate: oneMonthAgo,
    endDate: today,
    key: "selection",
  });
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [openRow, setOpenRow] = useState(null);
  const [city, setCity] = useState("");
  const [hub, setHub] = useState("");
  const [getAllHubsListData, setGetAllHubsListData] = useState(null);
  const ledgerRecords = wheelalignmentData?.dataList || [];
  const totalRecords = ledgerRecords.length;
  const totalPages = Math.max(1, Math.ceil(totalRecords / rowsPerPage));
  const displayedRecords = ledgerRecords.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const startRecord = totalRecords === 0 ? 0 : page * rowsPerPage + 1;
  const endRecord = Math.min((page + 1) * rowsPerPage, totalRecords);
  const [searchQuery, setSearchQuery] = useState("");
  const [tablePage, setTablePage] = useState(0);
  const tableRowsPerPage = 10;
  const [showExportMenu, setShowExportMenu] = useState(false);

  const toggleDrawer = (id) => {
    setOpenRow(openRow === id ? null : id);
  };

  const filteredData = useMemo(() => {
    if (!wheelalignmentData?.dataList) return [];
    const filtered = wheelalignmentData?.dataList?.filter(
      (item) =>
        item.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.licensePlate?.toLowerCase().includes(searchQuery.toLowerCase()),
    );
    // Apply sorting
    if (sortConfig.key) {
      return [...filtered].sort((a, b) => {
        let aVal = a[sortConfig.key] ?? "";
        let bVal = b[sortConfig.key] ?? "";
        if (typeof aVal === "string") aVal = aVal.toLowerCase();
        if (typeof bVal === "string") bVal = bVal.toLowerCase();
        if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
        if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      });
    }
    return filtered;
  }, [wheelalignmentData, searchQuery, sortConfig]);

  const paginatedTableData = filteredData.slice(
    tablePage * tableRowsPerPage,
    (tablePage + 1) * tableRowsPerPage,
  );

  const exportCSV = () => {
    const headers = [
      "Vehicle Name",
      "Registration No",
      "City",
      "Hub",
      "Last Alignment Odometer",
      "Last Alignment Date",
      "Current Odometer",
      "Vehicle Modal Text",
      "Alignment Required",
      "Severity",
      "Km Since Last Alignment",
      "Status Message",
      "Latest Wheel Alignment Date",
      "Latest Wheel Alignment Ododmeter Reading",
      "Latest Wheel Alignment Rotated",
    ];
    const rows = filteredData.map((row) => [
      row?.name || "-",
      row?.licensePlate || "-",
      cities[row?.cityId] || "-",
      getAllHubsListData.find((hub) => hub?.id === row?.hubId)?.hubName || "-",
      row?.lastAlignmentOdometer || 0,
      row?.lastAlignmentOdometer || 0,
      row?.currentOdometer || 0,
      row?.vehicleModelText || "-",
      row?.alignmentRequired || "-",
      row?.kmSinceLastAlignment || "-",
      row?.statusMessage || "-",
      row?.latestWheelAlignment?.serviceDate || "-",
      row?.latestWheelAlignment?.ododmeterReading || "-",
      row?.latestWheelAlignment?.isRotated || "-",
    ]);

    const csvContent = [
      headers.join(","),
      ...rows.map((r) => r.join(",")),
    ].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `vehicle_revenue_${new Date().toISOString().split("T")[0]}.csv`;
    a.click();
    URL.revokeObjectURL(url);
    setShowExportMenu(false);
  };

  function formatDateForApi(date, type) {
    if (!date) return "";
    const pad = (n) => (n < 10 ? "0" + n : n);
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    let hours = type === "start" ? "00" : "23";
    let minutes = type === "start" ? "00" : "59";
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  useEffect(() => {
    if (page > totalPages - 1) {
      setPage(Math.max(totalPages - 1, 0));
    }
  }, [page, totalPages]);

  const getAllHubsList = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/hubs?limit=1000`);
      const data = await response.json();
      if (data?.statusCode === "0100")
        setGetAllHubsListData(data?.entities?.rows);
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  const getWheelAlignmentDetails = async (selectedCity = city, selectedHub = hub) => {
    const formattedStartDate = formatDateForApi(
      selectionRange?.startDate,
      "start",
    );
    const formattedEndDate = formatDateForApi(selectionRange?.endDate, "end");
    let query = "";
    if (selectedCity) {
      query += `&cityId=${selectedCity}`;
    }
    if (selectedHub) {
      query += `&hubId=${selectedHub}`;
    }
    try {
      const response = await fetch(
        `${apiUrl}/api/dashboardreports/alignment-notification-dashboard?${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setWheelAlignmentData(data?.dataValues);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching get vehicle listings:", error);
    }
  };

  useEffect(() => {
    getWheelAlignmentDetails();
    getAllHubsList();
  }, []);

  const dashboardSections = [
    {
      title: "Count Overview",
      iconBg: "bg-blue-600",
      gridView: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-8",
      cards: [
        {
          title: "Critical Count",
          value: wheelalignmentData?.criticalCount,
          sub: "Count",
        },
        {
          title: "High Count",
          value: wheelalignmentData?.highCount,
          sub: "Count",
        },

        {
          title: "Medium Count",
          value: wheelalignmentData?.mediumCount,
          sub: "Count",
        },
        {
          title: "Low Count",
          value: wheelalignmentData?.lowCount,
          sub: "Count",
        },
      ],
    },
  ];

  return (
    <div>
      <div className="my-6">
        <h1 className="flex justify-start text-xl font-semibold">
          Wheel Alignment Dashboard
        </h1>
        <div className="flex gap-4 justify-end">
          <div className="w-96 h-10 max-w-96 relative">
            <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none z-10">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
                  stroke="#9CA3AF"
                  strokeWidth="1.33333"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M13.9995 13.9995L11.1328 11.1328"
                  stroke="#9CA3AF"
                  strokeWidth="1.33333"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <input
              type="text"
              placeholder="Search vehicles by name or plate number..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full h-10 pl-9 pr-4 py-2.5 rounded-[10px] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-300 text-sm focus:outline-indigo-500 transition-all"
            />
          </div>

          <div className="pl-4 flex justify-start items-start relative">
            <button
              onClick={() => setShowExportMenu(!showExportMenu)}
              className="px-4 py-2.5 bg-indigo-600 rounded-[10px] flex justify-start items-center gap-2 hover:bg-indigo-700 transition-colors"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M8 2V10M8 10L5.5 7.5M8 10L10.5 7.5"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2 12V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V12"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </svg>
              <span className="text-white text-sm font-semibold">Export</span>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path
                  d="M2 4L6 8L10 4"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>

            {showExportMenu && (
              <div className="absolute top-full right-0 mt-1 bg-white rounded-xl shadow-lg border border-gray-200 py-1 z-50 min-w-[140px]">
                <button
                  onClick={exportCSV}
                  className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 transition-colors flex items-center gap-2"
                >
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path
                      d="M7 1.5V8.5M7 8.5L4.5 6M7 8.5L9.5 6"
                      stroke="#374151"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M1.5 10.5V11.5C1.5 12.0523 1.94772 12.5 2.5 12.5H11.5C12.0523 12.5 12.5 12.0523 12.5 11.5V10.5"
                      stroke="#374151"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                  Export CSV
                </button>
              </div>
            )}
          </div>

          {/* <DaterangePicker
            selectionRange={selectionRange}
            setSelectionRange={setSelectionRange}
            style={-10}
          /> */}
          <select
            className="w-40 h-11 px-4 pr-10 border border-gray-300 rounded-lg bg-white text-gray-700 shadow-sm outline-none appearance-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
            value={city}
            onChange={(e) => setCity(e.target.value)}
          >
            <option value="">Select City</option>
            {cities &&
              Object.entries(cities).map(([key, value]) => (
                <option key={key} value={key}>
                  {value}
                </option>
              ))}
          </select>
          <select
            className="w-40 h-11 px-4 pr-10 border border-gray-300 rounded-lg bg-white text-gray-700 shadow-sm outline-none appearance-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
            value={hub}
            onChange={(e) => setHub(e.target.value)}
          >
            <option value="">Select Hub</option>
            {getAllHubsListData &&
              getAllHubsListData.map((item, index) => (
                <option key={index} value={item?.id}>
                  {item?.hubName}
                </option>
              ))}
          </select>

          <button
            onClick={() => {
              getWheelAlignmentDetails();
            }}
            className="p-2 bg-blue-400"
          >
            Search
          </button>
          <button
            onClick={() => {
              setCity("");
              setHub("");
              setSearchQuery("");
              getWheelAlignmentDetails("", "");
            }}
            className="p-2 bg-red-400"
          >
            Clear
          </button>
        </div>
      </div>

      <div className="space-y-8">
        {dashboardSections.map((section, index) => (
          <div key={index} className="bg-white rounded-3xl p-5 shadow-sm">
            {/* Header */}
            <div className="flex items-center gap-3 border-b-2 border-gray-200 pb-3 mb-5">
              <div
                className={`w-10 h-10 rounded-xl ${section.iconBg} flex items-center justify-center text-white font-bold`}
              >
                📊
              </div>

              <h2 className="text-xl font-semibold">{section.title}</h2>
            </div>

            {/* Cards */}
            <div className={`${section.gridView} gap-5`}>
              {section.cards.map((card, i) => (
                <div
                  key={i}
                  className="border rounded-2xl p-5 bg-white shadow-sm hover:shadow-md transition h-44"
                >
                  <p className="text-gray-500 text-sm font-medium">
                    {card.title}
                  </p>

                  <div className="mt-5 text-center">
                    <h2 className="text-4xl font-bold text-gray-800">
                      {card.value ?? 0}
                    </h2>

                    <p className="text-xs text-gray-400 mt-3">{card.sub}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="rounded-xl shadow-md overflow-x-auto my-4 my-4">
        <table className="min-w-full border-collapse">
          <thead className="bg-gradient-to-r from-indigo-50 to-blue-50 border-b border-gray-200">
            <tr className="text-xs uppercase tracking-wider text-gray-700">
              <th className="px-6 py-4 text-left font-semibold">Name</th>

              <th className="px-6 py-4 text-left font-semibold">
                License Plate
              </th>

              <th className="px-6 py-4 text-left font-semibold">
                City
              </th>

              <th className="px-6 py-4 text-left font-semibold">
                Vehicle Model Text
              </th>

              <th className="px-6 py-4 text-left font-semibold">
                Alignment Required
              </th>

              <th className="px-6 py-4 text-left font-semibold">Severity</th>

              <th className="px-6 py-4 text-left font-semibold">
                Km SInce Last Alignment
              </th>

              <th className="px-6 py-4 text-center font-semibold">
                Status Message
              </th>
            </tr>
          </thead>

          <tbody>
            {paginatedTableData.map((record, index) => (
              <React.Fragment key={record.id}>
                {/* Main Row */}
                <tr
                  onClick={() => toggleDrawer(record.id)}
                  className={`cursor-pointer transition-all duration-300 hover:bg-blue-50 ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  }`}
                >
                  <td className="px-6 py-5">{record?.name || "-"}</td>

                  <td className="px-6 py-5">{record?.licensePlate || "-"}</td>

                  <td className="px-6 py-5">{cities[record?.cityId] || "-"}</td>

                  <td className="px-6 py-5">
                    <span className="rounded-full bg-indigo-100 px-3 py-1 text-sm font-semibold text-indigo-700">
                      {record.vehicleModelText || "-"}
                    </span>
                  </td>

                  <td className="px-6 py-5">
                    <span className="rounded-full bg-indigo-100 px-3 py-1 text-sm font-semibold text-indigo-700">
                      {record.alignmentRequired ? "True" : "False" || "-"}
                    </span>
                  </td>
                  <td className="px-6 py-5">{record?.severity || "-"}</td>
                  <td className="px-6 py-5">
                    {record?.kmSinceLastAlignment || "-"}
                  </td>
                  <td className="px-6 py-5">{record?.statusMessage || "-"}</td>
                </tr>

                {openRow === record.id && (
                  <tr>
                    <td colSpan={7} className="bg-gray-50 p-6">
                      <div className="bg-white rounded-2xl shadow-md border p-6">
                        <h2 className="text-xl font-bold text-gray-800 mb-5 border-b pb-3">
                          Other Details
                        </h2>

                        <div className="grid grid-cols-2 gap-4 text-sm">
                          <div>
                            <p className="text-gray-500">City</p>
                            <p className="font-semibold">
                              {cities[record.cityId] || "-"}
                            </p>
                          </div>

                          <div>
                            <p className="text-gray-500">Hub</p>
                            <p className="font-semibold">
                              {getAllHubsListData.find(
                                (hub) => hub?.id === record?.hubId,
                              )?.hubName || "-"}
                            </p>
                          </div>

                          {/* <div>
                            <p className="text-gray-500">Attachments</p>
                          </div> */}

                          <div>
                            <p className="text-gray-500">
                              Last Alignment Odometer
                            </p>
                            <p className="font-semibold">
                              {record.lastAlignmentOdometer || "-"}
                            </p>
                          </div>

                          <div>
                            <p className="text-gray-500">
                              Lastest Wheel Alignment
                            </p>
                            <p className="font-semibold">
                              Is Rotated -{" "}
                              {record.latestWheelAlignment?.isRotated ? "True" : "False" || "N/A"}
                              <br />
                              Odometer Reading -{" "}
                              {record.latestWheelAlignment?.ododmeterReading ||
                                "N/A"}
                            </p>
                          </div>

                          <div>
                            <p className="text-gray-500">Last Alignment Date</p>
                            <p>{record?.lastAlignmentDate || "-"}</p>
                          </div>

                          <div>
                            <p className="text-gray-500">Current Odometer</p>
                            <p>{record?.currentOdometer || "-"}</p>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
            {paginatedTableData.length === 0 && (
              <tr>
                <td colSpan={7} className="px-6 py-8 text-center text-gray-500">
                  No records found.
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <div className="self-stretch px-6 py-4 border-t-[0.80px] border-gray-200 inline-flex justify-between items-center">
          <div className="text-gray-500 text-sm font-normal">
            Showing {tablePage * tableRowsPerPage + 1} to{" "}
            {Math.min((tablePage + 1) * tableRowsPerPage, filteredData.length)}{" "}
            of {filteredData.length} vehicles
          </div>
          <div className="flex items-center gap-2">
            <button
              disabled={tablePage === 0}
              onClick={() => setTablePage((p) => p - 1)}
              className="p-2 rounded-[10px] outline outline-[0.80px] outline-gray-300 disabled:opacity-50 hover:bg-gray-50"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M10 4L6 8L10 12"
                  stroke="#1A1A1A"
                  strokeWidth="1.33333"
                  strokeLinecap="round"
                />
              </svg>
            </button>
            <div className="text-gray-700 text-sm font-medium">
              Page {tablePage + 1} of{" "}
              {Math.ceil(filteredData.length / tableRowsPerPage)}
            </div>
            <button
              disabled={
                (tablePage + 1) * tableRowsPerPage >= filteredData.length
              }
              onClick={() => setTablePage((p) => p + 1)}
              className="p-2 rounded-[10px] outline outline-[0.80px] outline-gray-300 disabled:opacity-50 hover:bg-gray-50"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M6 4L10 8L6 12"
                  stroke="#1A1A1A"
                  strokeWidth="1.33333"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Wheelalignmentdashboard;
